// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-error {
  margin-top: 8px;
  font-size: 16px;
  color: #b00020;
}

.nec-stack {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.nec-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.nec-header {
  font-weight: 700;
  font-size: 16px;
  color: #013868;
  margin-bottom: 8px;
}

.nec-control {
  width: 100%;
  border-radius: 8px;
}

.nec-input {
  width: 100%;
  height: 38px;
  padding: 25px;
  padding-left: 15px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0);
  background: #eef3f7;
  outline: none;
  font-size: 16px;
}

.nec-input:focus {
  border-color: rgba(11, 78, 162, 0.45);
  box-shadow: 0 0 0 3px rgba(11, 78, 162, 0.12);
}

.nec-hint {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}`, "",{"version":3,"sources":["webpack://./src/web/component/NewInventory/styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B","sourcesContent":[".form-error {\r\n  margin-top: 8px;\r\n  font-size: 16px;\r\n  color: #b00020;\r\n}\r\n\r\n.nec-stack {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 30px;\r\n}\r\n\r\n.nec-block {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.nec-header {\r\n  font-weight: 700;\r\n  font-size: 16px;\r\n  color: #013868;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.nec-control {\r\n  width: 100%;\r\n  border-radius: 8px;\r\n}\r\n\r\n.nec-input {\r\n  width: 100%;\r\n  height: 38px;\r\n  padding: 25px;\r\n  padding-left: 15px;\r\n  border-radius: 8px;\r\n  border: 1px solid rgba(0, 0, 0, 0);\r\n  background: #eef3f7;\r\n  outline: none;\r\n  font-size: 16px;\r\n}\r\n\r\n.nec-input:focus {\r\n  border-color: rgba(11, 78, 162, 0.45);\r\n  box-shadow: 0 0 0 3px rgba(11, 78, 162, 0.12);\r\n}\r\n\r\n.nec-hint {\r\n  font-size: 14px;\r\n  color: rgba(0, 0, 0, 0.6);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
